export type appFeature =
  | 'MEDIA_MANAGER'
  | 'ACTIVE_CHAMPIONSHIPS'
  | 'JOYSTICK'
  | 'OBS_INTEGRATION'
  | 'TOURNAMENT_ANALYTICS'
  | 'AI_CHAT_ASSISTANT';

export const APP_FEATURES: readonly appFeature[] = [
  'MEDIA_MANAGER',
  'ACTIVE_CHAMPIONSHIPS',
  'JOYSTICK',
  'OBS_INTEGRATION',
  'TOURNAMENT_ANALYTICS',
  'AI_CHAT_ASSISTANT',
];

export interface FeatureDto {
  feature: appFeature;
  isEnabled: boolean;
}

export type Feature = Record<appFeature, boolean>;
